import axios from 'axios';

export const getMetTags = async (host, collectionId, surl, csrf) => {
  const url = `${host}!soap.jsonget?n=Metatag&SURL=${surl}&EXPAND_LIST=TRUE&TAG_FOR_COLLECTION_EDITED=${collectionId}&JSON=T&CSRF=${csrf}`;
  try {
    const response = await axios.get(url);
    if (
      response.status == 200 &&
      response.data.metatags &&
      Array.isArray(response.data.metatags)
    ) {
      return response.data.metatags;
    } else {
      console.log('Error fetching metatags:', response);
      return null;
    }
  } catch (error) {
    console.error('Error fetching metatags:', error);
    return null;
  }
};

export const getAllowedFileTypes = async (
  host,
  categoryIdToUpload,
  surl,
  csrf,
  fileType,
  fileName
) => {
  const url = `${host}!ump.universal_browser?JSON=T&ALLOWED_TYPES_ONLY=TRUE&DEFAULT_PROFILE_LOADER=FALSE&category_id=${categoryIdToUpload}&surl=${
    surl || ''
  }&csrf=${csrf}`;
  const formData = new FormData();
  const blob = new Blob(['Lorem ipsum'], { type: fileType });
  formData.append('file', blob, fileName);
  try {
    const response = await axios.post(url, formData);
    if (
      response.status == 200 &&
      response.data &&
      Array.isArray(response.data.filters)
    ) {
      return response.data?.filters;
    } else {
      console.error('Error fetching fileTypes:', response);
      return null;
    }
  } catch (error) {
    console.error('Error fetching fileTypes:', error);
    return null;
  }
};

export const uploadFileWithMetaData = async (
  host,
  categoryIdToUpload,
  surl,
  csrf,
  dataUrl,
  nameOfTheFile,
  metaValuesParams,
  file
) => {
  const url = `${host}!ump.universal_browser?JSON=T&DEFAULT_PROFILE_LOADER=FALSE&category_id=${categoryIdToUpload}&surl=${
    surl || ''
  }&csrf=${csrf}${metaValuesParams}`;
  // const FileBlob = await fetch(dataUrl).then((res) => res.blob());
  const formData = new FormData();
  formData.append('File', file, nameOfTheFile);
  try {
    const promise = axios.post(url, formData);
    return promise;
  } catch (error) {
    console.error('Error Uploading file', error);
    return null;
  }
};

export const getJobStatus = async (host, surl, csrf, jobId, loaderId) => {
  const url = `${host}!soap.jsonget?n=SHOW_LOADER&summary=JOB_ONLY&surl=${
    surl || ''
  }&csrf=${csrf}&loader_id=${loaderId}&job_id=${jobId}`;
  try {
    const promise = axios.get(url);
    return promise;
  } catch (error) {
    console.error('Error getting job status', error);
    return null;
  }
};
